import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import BaseController from '../BaseController';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { LandingPageItems } from '../../interfaces/landing-page-items';
import { getFoundationDataContext } from '../../app/bootstrap-foundation';

enum LandingPageRule {
  INSTITUCIONAL = 'I',
  LINK = 'L',
  IMAGE = 'M',
  ALERT = 'A'
}

@Controller({ component: 'login-switch-layout', fragment: 'login-switch' })
class LoginSwitchController extends BaseController {

  @Inject('login-panel')
    loginPanelApi!: PanelAPI;

  @Inject('login-landing-page-panel')
    loginLandingPagePanelApi!: PanelAPI;

  getLandingPageItemData(data: LandingPageItems[], landingPageItem: string): LandingPageItems[] | undefined {
    return data.filter(item => item.ieTipoRegra === landingPageItem)
  }

  @OnMount({ target: 'login-panel' })
  onMountLayout(): void {
    const { loginLandingPagePanelApi, loginPanelApi } = this;

    HttpService.get(APPLICATION_ENDPOINTS.GET_LANDING_PAGE_ITEMS)
      .then(res => {
        const data = res.body as LandingPageItems[];
        let instCardsData = this.getLandingPageItemData(data, LandingPageRule.INSTITUCIONAL);
        const linkData = this.getLandingPageItemData(data, LandingPageRule.LINK);
        const alertData = this.getLandingPageItemData(data, LandingPageRule.ALERT);
        const imageData = this.getLandingPageItemData(data, LandingPageRule.IMAGE);

        instCardsData = instCardsData?.filter(card => card.ieSituacao === 'A');

        if (instCardsData && instCardsData.length >= 2) {
          const appContext = getFoundationDataContext();
          appContext.set({ 'landingPage': true })

          this.context.set({
            alertData,
            imageData,
            instCardsData,
            linkData,
          });
          loginLandingPagePanelApi.setVisible(true);
        } else {
          loginPanelApi.setVisible(true);
        }
      })
      .catch(() => loginPanelApi.setVisible(true));
  }

}

export default LoginSwitchController;